<template>
  <section class="Login">
    <div>
      <img class="Login-logo" src="@/assets/images/kenzo-homme-logo.svg" alt="">
      <Password :callback="onLogin"/>
    </div>
  </section>
</template>

<script>
import Password from '@/components/Password.vue'
// import { store } from '@/store'
import { inject } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'App',
  components: {
    Password,
  },
  // data() {
  //   return {
  //     sharedState: store.state
  //   }
  // },
  // inject: ['store'],
  setup() {
    const store = inject('store')
    const router = useRouter()

     function onLogin() {
       store.auth()
       router.push('/')
     }
    return {
      store,
      onLogin,
    }
  }
}
</script>

<style lang="stylus">
.Login
  width 100vw
  height 100vh
  background-image url('../assets/bali-background.jpg')
  background-size cover
  display flex
  align-items center
  justify-content center

  &-logo
    margin 0% auto
    width 210px

</style>
